import React, {useMemo} from "react";
import {Link} from "react-router-dom";
import objectPath from "object-path";
import {useHtmlClassService} from "../../core/AppLayout";

export function Brand() {
    const uiService = useHtmlClassService();

    const layoutProps = useMemo(() => {
        return {
            brandClasses: uiService.getClasses("brand", true),
            asideSelfMinimizeToggle: objectPath.get(
                uiService.config,
                "aside.self.minimize.toggle"
            ),
            headerLogo: uiService.getLogo(),
            headerStickyLogo: uiService.getStickyLogo()
        };
    }, [uiService]);

    return (
        <>
            {/* begin::Brand */}
            <div className={`brand flex-column-auto ${layoutProps.brandClasses}`}
                 id="od_brand"
            >
                {/* begin::Logo */}
                <Link to="" className="brand-logo">
                    <img alt="logo" height={35} src={layoutProps.headerLogo}/>
                    <img className='minimized-logo' alt="logo" height={35} src={layoutProps.headerStickyLogo}/>
                </Link>
                {/* end::Logo */}

                {!layoutProps.asideSelfMinimizeToggle && (
                    <>
                        <Link to="" className="brand-logo">
                            <img alt="logo" height={35} src={layoutProps.headerStickyLogo}/>
                        </Link>
                    </>
                )}
            </div>
            {/* end::Brand */}
        </>
    );
}
